import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { RoundFilledButton } from '@common/overlay-manager';

interface RemoveItemDialogProps {
  onCancel?: React.MouseEventHandler<HTMLButtonElement>;
  onRemove?: React.MouseEventHandler<HTMLButtonElement>;
}

export function RemoveItemDialog({ onCancel, onRemove }: RemoveItemDialogProps) {
  return (
    <Wrapper>
      <p>
        기본상품을 모두 삭제하는 경우<br />추가상품도 모두 삭제됩니다.<br />선택하신 상품을 삭제하시겠습니까?
      </p>
      <ButtonHolder>
        <RoundFilledButton size='lg' variant='default' onClick={onCancel}>
          취소
        </RoundFilledButton>
        <RoundFilledButton size='lg' onClick={onRemove}>
          삭제
        </RoundFilledButton>
      </ButtonHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  p {
    color: ${vars.v3Color.gray600};
    font-weight: 400;
    font-size: 15px;
    line-height: 1.6;
  }
`;

const ButtonHolder = styled.div`
  display: flex;
  padding: 40px 24px 24px 24px;
  button {
    flex: 1;
    margin-right: 8px;
    &:first-of-type {
      border: 1px solid ${vars.v3Color.gray200};
      background: #fff; 
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
`;
